import React from "react";

function NotFound() {
  return (
    <div style={{ backgroundColor: "lightgray" }}>
      <h2>404!! Page Not Found</h2>
    </div>
  );
}

export default NotFound;
